import { Route, Routes } from "react-router";
import HeaderComponent from "./HeaderComponent";
import HomeContentPage from "./HomeContentPage";
import FooterComponent from "./FooterComponent";
import QuienesSomosPage from "./QuienesSomosPage";
import ContactanosPage from "./ContactanosPage";
import TerminosCondicionesPage from "./TerminosCondicionesPage";
import AvisoPrivacidadPage from "./AvisoPrivacidadPage";
import PerfilamientoFormPage from "./PerfilamientoFormPage";
import { Alert, Backdrop, CircularProgress, Snackbar, Typography } from "@mui/material";
import { useLayout } from "../context/LayoutContext";
import ThankYouPage from "./ThankYouPage";
import BlogPage from "./BlogPage";
import BlogContentDetailPage from "./BlogContentDetailPage";

export default function LayoutPage() {
    const { alert, loaderOpen, handleCloseAlert } = useLayout();

    return (
        <>
            <HeaderComponent />
            <Routes>
                <Route path="/" element={<HomeContentPage />} />
                <Route path="/home" element={<HomeContentPage />} />
                <Route path="/quienes-somos" element={<QuienesSomosPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:blogId" element={<BlogContentDetailPage />} />
                <Route path="/contactanos" element={<ContactanosPage />} />
                <Route path="/terminos-y-condiciones" element={<TerminosCondicionesPage />} />
                <Route path="/aviso-de-privacidad" element={<AvisoPrivacidadPage />} />
                <Route path="/perfilamiento" element={<PerfilamientoFormPage />} />
                <Route path="/preguntra-recibida" element={<ThankYouPage />} />
            </Routes>
            <FooterComponent />
            <Backdrop sx={(theme) => ({ backgroundColor: "#ffffff80", zIndex: theme.zIndex.modal + 1000 })} open={loaderOpen.open}>
                <div>
                    <CircularProgress color="inherit" />
                    <Typography>{loaderOpen.text}</Typography>
                </div>
            </Backdrop>
            <Snackbar open={alert.open} autoHideDuration={4000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity={alert.severity} variant="filled" sx={{ width: "100%" }}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </>
    );
}
